export const fr = {
  title: 'Couvert arboré',
  subtitle: '2000/2010, Hansen/UMD/Google/USGS/NASA',
  download_data: 'https://glad.umd.edu/dataset/global-2010-tree-cover-30-m',
  learn_more: 'http://science.sciencemag.org/content/342/6160/850',
  content: [
    {
      label: 'Fonction',
      value: 'Identifie les zones de couvert végétal',
    },
    {
      label: 'Résolution',
      value: '30 x 30 mètres',
    },
    {
      label: 'Couverture géographique',
      value: 'Superficie globale (hors îles Antarctiques et Arctiques)',
    },
    {
      label: 'Source',
      value:
        'Hansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available from: https://glad.umd.edu/dataset/global-2010-tree-cover-30-m.',
    },
    {
      label: 'Fréquence des mises à jour',
      value: '',
    },
    {
      label: 'Date du contenu',
      value: '2000 & 2010',
    },
    {
      label: 'Mises en garde',
      value:
        "Dans le cadre de cette étude, une « couverture arborée » a été définie comme une végétation d'une hauteur supérieure à 5 mètres. Une « couverture arborée » est une présence biophysique d'arbres et peut prendre la forme de forêts naturelles ou bien de plantations qui peuvent présenter une large diversité de densités de canopé.",
    },
    {
      label: 'Licence',
      value: 'CC BY 4.0',
    },
  ],
  overview: {
    label: 'Aperçu',
    value:
      "Cet ensemble de données, fruit d'une collaboration entre le GLAD (Global Land Analysis & ; Discovery) de l'université du Maryland, Google, l'USGS et la NASA, affiche la couverture arborée sur l'ensemble du globe (à l'exception de l'Antarctique et d'un certain nombre d'îles de l'Arctique) pour les années 2000 et 2010 avec une résolution de 30 × 30 mètres. Le « pourcentage de couverture arborée » est défini comme la densité de la couverture arborée de la surface terrestre et dispose d'un code de couleurs par niveau de densité (voir la légende).\n\nLes données de cette couche ont été générées à l'aide de l'imagerie satellitaire multispectrale du capteur ETM+ (cartographie thématique améliorée) de Landsat 7. Les observations de surface claire de plus de 600 000 images ont été analysées à l'aide de Google Earth Engine, une plate-forme en nuage pour l'observation de la terre et l'analyse des données, afin de déterminer la couverture arborée par pixel à l'aide d'un algorithme d'apprentissage supervisé.\n\nLa densité de canopée du couvert forestier des données affichées varie en fonction de la sélection – utilisez la légende de la carte pour modifier le niveau minimum de densité de canopée du couvert forestier.",
  },
  citation: {
    label: 'Citation',
    value:
      'Use the following credit when these data are displayed:\nSource: Hansen/UMD/Google/USGS/NASA, accessed through Global Forest Watch\n\nUse the following credit when these data are cited:\nHansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available on-line from:https://glad.umd.edu/dataset/global-2010-tree-cover-30-m. Accessed through Global Forest Watch on 11/02/2025. www.globalforestwatch.org',
  },
};
